import { css } from 'styled-components';
import { getMultipliedIndent } from "../../../theme/selectors";
import { createGridStyle } from "./gridStyles";
import { gridPropsDict } from "../types";

var addTrackSizeStyle = function addTrackSizeStyle(propNameCSS, propValue) {
  if (typeof propValue === 'number') {
    return "".concat(propNameCSS, ": repeat(").concat(propValue, ", 1fr);");
  }

  return "".concat(propNameCSS, ": ").concat(propValue, ";");
};

var addGapSizeStyle = function addGapSizeStyle(propNameCSS, propValue, theme) {
  var gapValue = getMultipliedIndent(theme, Number(propValue));
  return "".concat(propNameCSS, ": ").concat(gapValue, ";");
};

var addColContainerStyle = createGridStyle('col', gridPropsDict, addTrackSizeStyle);
var addRowContainerStyle = createGridStyle('row', gridPropsDict, addTrackSizeStyle);
var addAutoColStyle = createGridStyle('autoCol', gridPropsDict);
var addAutoRowStyle = createGridStyle('autoRow', gridPropsDict);
var addGapStyle = createGridStyle('gap', gridPropsDict, addGapSizeStyle);
var addGapColStyle = createGridStyle('gapCol', gridPropsDict, addGapSizeStyle);
var addGapRowStyle = createGridStyle('gapRow', gridPropsDict, addGapSizeStyle);
var addJustifyItemsStyle = createGridStyle('justifyItems', gridPropsDict);
var addAlignItemsStyle = createGridStyle('alignItems', gridPropsDict);
var addJustifyContentStyle = createGridStyle('justifyContent', gridPropsDict);
var addAlignContentStyle = createGridStyle('alignContent', gridPropsDict);
export var addGridContainerStyles = function addGridContainerStyles() {
  return css(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], addColContainerStyle, addRowContainerStyle, addAutoColStyle, addAutoRowStyle, addGapStyle, addGapColStyle, addGapRowStyle, addJustifyItemsStyle, addAlignItemsStyle, addJustifyContentStyle, addAlignContentStyle);
};